import React, { useState } from 'react';
import { Text } from 'rebass';
import Button from '@/components/Button/Button';
import Modal, { ModalBody, ModalFooter } from '@/components/Modal';
import {
  TWO_FACTOR_PROMPT_DISMISSED_AT_KEY,
  TWO_FACTOR_PROMPT_KEY,
} from '@/services/auth';
import CodeVerificationModal from './CodeVerificationModal';

const TwoFactorPrompt: React.FC = () => {
  const [open, setOpen] = useState<'prompt' | 'setup' | undefined>(() =>
    sessionStorage.getItem(TWO_FACTOR_PROMPT_KEY) === 'true'
      ? 'prompt'
      : undefined
  );

  if (!open) return null;

  const close = () => {
    sessionStorage.removeItem(TWO_FACTOR_PROMPT_KEY);
    setOpen(undefined);
  };

  if (open === 'setup') {
    return <CodeVerificationModal flow="turnOnTwoFactor" onClose={close} />;
  }

  const setupNow = () => {
    sessionStorage.removeItem(TWO_FACTOR_PROMPT_KEY);
    setOpen('setup');
  };
  const remindLater = () => {
    close();
    localStorage.setItem(
      TWO_FACTOR_PROMPT_DISMISSED_AT_KEY,
      new Date().toISOString()
    );
  };

  return (
    <Modal
      title="Protect your account with two-factor authentication"
      onClose={remindLater}
    >
      <ModalBody>
        <Text>
          Add an extra layer of security by requiring a verification code when
          you sign in with your email and password.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={setupNow}>Set up now</Button>
        <Button variant="outline" onClick={remindLater}>
          Remind me later
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TwoFactorPrompt;
